import React from 'react';

import { Text } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';
import { View } from 'react-native';

const Bullet = ({ label, value }: { label: string; value: string }) => (
  <View style={{ marginBottom: 8 }}>
    <Text variant="body" fontWeight="bold">
      • {label}{' '}
      <Text variant="body" fontWeight="normal">
        {value}
      </Text>
    </Text>
  </View>
);

export const DeliveryTermsUS = () => {
  const { formatMessage } = useIntl();

  return (
    <>
      <Text variant="headerThree" mb="$4">
        {formatMessage({
          id: 'deliveryTerms.title',
          defaultMessage: 'Delivery on the BK App and bk.com',
        })}
      </Text>
      <Text variant="body" mb="$4">
        {formatMessage({
          id: 'deliveryTerms.intro',
          defaultMessage:
            'Delivery offered at participating U.S. restaurants on the BK App and bk.com. Minimum $5 order required (before taxes and fees). Prices higher than at restaurants. BK account registration is required. Delivery powered by third-party delivery providers, and subject to availability and restaurant delivery hours. Print coupons are not valid on delivery orders. Not all digital offers are available on delivery. Check digital offer terms at bk.com/offers before ordering. Fees are based on order subtotal.',
        })}
      </Text>

      {/* All states */}
      <Text variant="headerThree" mb="$2">
        {formatMessage({
          id: 'deliveryTerms.statesHeading',
          defaultMessage: 'All states (except California and Colorado):',
        })}
      </Text>
      <View style={{ paddingLeft: 16 }}>
        <Bullet
          label={formatMessage({ id: 'deliveryTerms.feeLabel', defaultMessage: 'Delivery Fee:' })}
          value={formatMessage({
            id: 'deliveryTerms.feeValue',
            defaultMessage: '$2.99 ($0 for orders $25+)',
          })}
        />
        <Bullet
          label={formatMessage({
            id: 'deliveryTerms.serviceFeeLabel',
            defaultMessage: 'Service Fee:',
          })}
          value={formatMessage({
            id: 'deliveryTerms.serviceFeeValue',
            defaultMessage: '15% of order subtotal',
          })}
        />
        <Bullet
          label={formatMessage({
            id: 'deliveryTerms.smallCartLabel',
            defaultMessage: 'Small Cart Fee:',
          })}
          value={formatMessage({
            id: 'deliveryTerms.smallCartValue',
            defaultMessage: '$2.50 on orders under $10',
          })}
        />
      </View>

      {/* Colorado */}
      <Text variant="headerThree" mt="$4" mb="$2">
        {formatMessage({ id: 'deliveryTerms.coloradoHeading', defaultMessage: 'Colorado:' })}
      </Text>
      <View style={{ paddingLeft: 16 }}>
        <Bullet
          label={formatMessage({ id: 'deliveryTerms.feeLabel', defaultMessage: 'Delivery Fee:' })}
          value={formatMessage({
            id: 'deliveryTerms.feeValue',
            defaultMessage: '$2.99 ($0 for orders $25+)',
          })}
        />
        <Bullet
          label={formatMessage({
            id: 'deliveryTerms.serviceFeeLabel',
            defaultMessage: 'Service Fee:',
          })}
          value={formatMessage({
            id: 'deliveryTerms.serviceFeeValue',
            defaultMessage: '15% of order subtotal',
          })}
        />
        <Bullet
          label={formatMessage({
            id: 'deliveryTerms.smallCartLabel',
            defaultMessage: 'Small Cart Fee:',
          })}
          value={formatMessage({
            id: 'deliveryTerms.smallCartValue',
            defaultMessage: '$2.50 on orders under $10',
          })}
        />
        <Bullet
          label={formatMessage({
            id: 'deliveryTerms.retailFeeLabel',
            defaultMessage: 'Colorado Retail Delivery Fee:',
          })}
          value={formatMessage({
            id: 'deliveryTerms.retailFeeValue',
            defaultMessage:
              'A $0.29 Retail Delivery Fee is required by law for deliveries in the State of Colorado',
          })}
        />
      </View>

      {/* California */}
      <Text variant="headerThree" mt="$4" mb="$2">
        {formatMessage({ id: 'deliveryTerms.californiaHeading', defaultMessage: 'California:' })}
      </Text>
      <View style={{ paddingLeft: 16 }}>
        <Bullet
          label={formatMessage({ id: 'deliveryTerms.feeLabel', defaultMessage: 'Delivery Fee:' })}
          value={formatMessage({ id: 'deliveryTerms.caFeeValue', defaultMessage: '$3.00' })}
        />
        <Bullet
          label={formatMessage({
            id: 'deliveryTerms.serviceFeeLabel',
            defaultMessage: 'Service Fee:',
          })}
          value={formatMessage({
            id: 'deliveryTerms.serviceFeeValue',
            defaultMessage: '15% of order subtotal',
          })}
        />
        <Bullet
          label={formatMessage({
            id: 'deliveryTerms.smallCartLabel',
            defaultMessage: 'Small Cart Fee:',
          })}
          value={formatMessage({
            id: 'deliveryTerms.smallCartValue',
            defaultMessage: '$2.50 on orders under $10',
          })}
        />
      </View>
    </>
  );
};
